// PGCard.jsx
import React from 'react';
import {
  FaMedal,
  FaCheckCircle,
  FaUserFriends,
  FaBed,
  FaStar,
  FaMapMarkerAlt,
  FaEye
} from 'react-icons/fa';
import './PGListing.css';

function PGCard({ pg, handleClick }) {
  const isPremium = pg.isPremium;
  const isVerified = pg.isVerified;

  return (
    <div
      className={`pg-card-wrapper ${isPremium ? 'premium-card-wrapper' : ''}`}
      onClick={() => handleClick(pg)}
    >
      {pg.showBooked && <div className="booked-overlay">Booked</div>}
      {isPremium && (
        <div className="premium-badge">
          <FaMedal /> Featured
        </div>
      )}

      <div
        className={`pg-card ${isPremium ? 'premium-card' : ''} ${
          isVerified && !isPremium ? 'verified-border' : ''
        }`}
      >
        {/* ✅ Thumbnail from thumbnailURL */}
        <img
          src={
            pg.thumbnailURL ||
            'https://dummyimage.com/400x300/cccccc/000000&text=No+Image'
          }
          alt={pg.pgName || 'PG Image'}
          className="pg-img"
        />

        <div className="pg-content">
          <h3>
            {pg.pgName}
            {isVerified && <FaCheckCircle className="verified-tick" />}
          </h3>

          {/* ✅ City & State */}
          <p>
            <FaMapMarkerAlt />{' '}
            {pg.city && pg.state
              ? `${pg.city}, ${pg.state}`
              : pg.city
              ? pg.city
              : pg.state
              ? pg.state
              : 'N/A'}
          </p>

     

          {/* Existing Details */}
          <p>
            <FaUserFriends /> {pg.occupancy || 'N/A'}
          </p>
          <p>
            <FaBed /> {pg.roomType || 'N/A'}
          </p>
          <p className="price">₹ {pg.rent || 'N/A'}/month</p>
          <p className="listing-id">
            Listing ID: <span>{pg.id}</span>
          </p>

               {/* ✅ Nearby Roads Section */}
          {Array.isArray(pg.nearbyRoads) && pg.nearbyRoads.length > 0 && (
            <div className="road-slider">
              {pg.nearbyRoads.map((road, index) => (
                <div key={index} className="road-info">
                  <span className="road-icon">📍</span>
                  <span>
                    {road.name || 'Unknown Road'}
                    {road.distance ? ` (${road.distance})` : ''}
                  </span>
                </div>
              ))}
            </div>
          )}

          <p className="rating">
            {[1, 2, 3, 4, 5].map((n) => (
              <FaStar key={n} color={'#d0d0d0'} />
            ))}
            {pg.views > 0 && (
              <>
                {' '}
                | <FaEye /> {pg.views}
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PGCard;
